<template>
  <div class="body-container">
    <div class="-header">
      <h2>
        <span class="mdi mdi-calendar mdi-36px"></span>
        調整された日程のキャンセル
      </h2>
      <div style="display: flex; justify-content: space-between;">
        <p>{{getCompanyName()}} </p>
        <p>{{getSeekerName()}}様</p>
      </div>
    </div>
    <!-- ローディング画面 -->
    <div class="loading-container" v-if="isLoading">
      <Loading/>
    </div>
    <!-- 変更画面 -->
    <div class="main-box" v-else-if="events.length > 0">
      <!-- STEP１ -->
      <template v-if="step === 0">
        <p class="-title">
          下記設定された日付をお選びください。
          <!-- ※「閉じる」を選択するとページを一度閉じます。<br> -->
        </p>
        <div class="edit-box">
          日程の選択：
          <select class="select" v-model="select">
            <option v-for="(t, idx) in events" :key="idx" :value="t">
              {{getStrDate(t.start)}} - {{getStrDate(t.end)}}
            </option>
          </select>
        </div>
        <!-- 変更は一旦なし（シナリオ変更の時の挙動などヒアリング要） -->
        <!-- <div style="padding: 8px;">
          区分：
          <b-radio v-model="type"
            name="type"
            native-value="modify">
            日程の変更
          </b-radio>
          <b-radio v-model="type"
            name="type"
            native-value="cancel">
            キャンセル
          </b-radio>
        </div> -->
        <hr>
        <div class="menu-btn">
          <button @click="changeStep(1)" class="button is-primary -right-8px" :disabled="!select">次　へ</button>
          <!-- 閉じられるのはwindow.open()で開いた画面のみなので削除 -->
          <!-- <button @click="closePage()" class="button is-danger">閉じる</button> -->
        </div>
      </template>
      <!-- STEP2 -->
      <template v-if="step === 1">
        <!-- 日程のキャンセル -->
        <template v-if="type === 'cancel'">
          <p class="-title">
            下記の日程をキャンセルします。<br>
            何かお伝えしたいことがございましたら下記に記載をお願い致します。
          </p>
          <div class="edit-box">
            <p>日程：{{getStrDate(select.start)}} - {{getStrDate(select.end)}}</p>
            <textarea
              class="textarea"
              placeholder="内容を入力"
              v-model="message">
            </textarea>
          </div>
          <div class="edit-box">
            <p>{{getSeekerName()}}様のEmailアドレス</p>
            <input
              class="input"
              placeholder="アドレスを入力"
              v-model="select.seeker_email"/>
          </div>
          <hr>
          <div class="menu-btn">
            <button @click="sendCancelSchedule()" class="button is-primary -right-8px" :disabled="isSended">送　信</button>
            <button @click="changeStep(0)" class="button" :disabled="isSended">戻　る</button>
          </div>
        </template>
      </template>
    </div>
    <div class="main-box" v-else>
      調整された日が既に古いか、もしくはページが見つかりませんでした。<br><br>
      <!-- 閉じられるのはwindow.open()で開いた画面のみなので削除 -->
      <!-- <button @click="close()" class="button">ウィンドウを閉じる</button> -->
    </div>
  </div>
</template>

<script>
import displayDate from '@/functions/displayDate'
import Loading     from '@/components/animations/Loading'
export default {
  components: {
    Loading
  },
  data () {
    return {
      isLoading: true,
      events: [],
      type: 'cancel',
      step: 0,
      select: null,
      message: null,
      isSended: false,
    }
  },
  mounted () {
    this.isLoading = true
    this.$store.dispatch('calendar/getEventFromScenarioAny', this.$route.params.id)
      .then((data) => {
        this.events = this.$_.filter(data, ((obj) => {
          return new Date(obj.start) > new Date()
        }))
        this.isLoading = false
      })
  },
  methods: {
    // 閉じられるのはwindow.open()で開いた画面のみなので削除
    // close () {
    //   window.close()
    // },
    sendCancelSchedule () {
      let inputMessage = null
      if (!this.select.seeker_email) {
        alert('Eメールアドレスを入力してください。')
      }else{
        // キャンセル用メッセージ作成
        if (this.message === null){
          inputMessage = '未入力'
        } else {
          inputMessage = this.message
        }
        const confirmMessage = `
          下記の内容で日程のキャンセル処理を行ってよろしいですか？
          日時：${this.getStrDate(this.select.start)} - ${this.getStrDate(this.select.end)}
          Email：${this.select.seeker_email}
          メッセージ：${inputMessage}
        `
        // 確認ダイアログで入力内容を確認して、trueの場合のみ処理を実行する
        if (window.confirm(confirmMessage)){
          this.isSended = true
          this.select.status = 2
          this.$store.dispatch('calendar/updateEventFromScenarioAny', this.select)
            .then((d) => {
              // 担当者側に通知メールを送付
              this.$store.dispatch('master/sendEmailContent', {
                to: this.select.email_list,
                subject: '日程のキャンセル連絡がございました【HRモンスター】',
                content: '\
                  ご担当者様<br><br>\
                  下記のキャンセル連絡を承りましたのでご連絡いたします。<br><br>\
                  【内容】' +
                  '<br>お名前：' + this.select.seeker_name + '様' +
                  '<br>Email：' + this.select.seeker_email +
                  '<br>日時：' + this.getStrDate(this.select.start) +
                  ' - ' + this.getStrDate(this.select.end) +
                  '<br>メッセージ：' + inputMessage +
                  '<br><br>以上、宜しくお願い致します。'
              })
                .then((d) => {
                  // 応募者側に通知メールを送付
                  this.$store.dispatch('master/sendEmailContent', {
                    to: this.select.seeker_email,
                    subject: '日程のキャンセル連絡を受付いたしました',
                    content:
                      this.select.seeker_name + '様<br><br>' +
                      '下記のキャンセル連絡を承りましたのでご連絡いたします。<br><br>\
                      【内容】' +
                      '<br>Email：' + this.select.seeker_email +
                      '<br>日時：' + this.getStrDate(this.select.start) +
                      ' - ' + this.getStrDate(this.select.end) +
                      '<br>メッセージ：' + inputMessage +
                      '<br><br>以上、宜しくお願い致します。'
                  })
                    .then((d) => {
                      alert('キャンセル受付が完了しました。\n本ページを閉じてください。')
                    })
                })
            })
            .catch(() => {
              alert('日程キャンセル受付でエラーが発生しました。\n時間を置いて、もう一度お試しください。')
              this.isSended = false
            })
        }
      }
    },
    getCompanyName () {
      if (this.events.length > 0) {
        return this.events[0].company_name
      } else {
        return ''
      }
    },
    getSeekerName () {
      if (this.events.length > 0) {
        return this.events[0].seeker_name
      } else {
        return ''
      }
    },
    changeStep (step) {
      this.step = step
    },
    // 閉じられるのはwindow.open()で開いた画面のみなので削除
    // closePage () {
    //   window.close()
    // },
    getStrDate (date) {
      return displayDate(new Date(date))
    }
  }
};
</script>

<style lang="scss" scoped>
.body-container {
  margin: 0 auto;
  background: #fbfbfb;
  max-width: 800px;
  width: 100%;
  height: 100vh;
  text-align: center;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
  .-header {
    width: 100%;
    padding: 24px;
    border-bottom: solid thin #ccc;
    h2 {
      font-size: 22px;
      font-weight: 600;
      text-align: left;
    }
    h2 > span {
      margin-right: 8px;
    }
    p {
      margin-left: 8px;
      text-align: left;
    }
  }
  .loading-container {
    position: fixed;
    z-index: 100;
    width: 100vw;
    height: 100vh;
    background: white;
    top: 0;
  }
  .main-box {
    margin-top: 48px;
    padding: 16px;
    border: solid thin #ccc;
    border-radius: 8px;
    text-align: left;
    .-title {
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 8px;
    }
    .edit-box {
      padding: 8px;
      p {
        margin-bottom: 4px;
      }
    }
    .menu-btn {
      display: flex; justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Calendar/EventFromScenarioAction.vue